<template>
  <v-row>
    <v-col
      cols="12"
      lg="3"
    >
      <kpi-card-component
        :title="$tc('Espace evenementiel')"
        :quantity="dashboard.events_kpi"
        :img="assets.homeProjects"
        :to="toProjects"
      />
    </v-col>
    <v-col
      cols="12"
      lg="3"
    >
      <kpi-card-component
        :title="$t('Clients')"
        :quantity="dashboard.clients_kpi"
        :img="assets.homeInspectionsOngoing"
        :to="toAllCustomers"
      />
    </v-col>
    <v-col
      cols="12"
      lg="3"
    >
      <kpi-card-component
        :title="$tc('Reservation')"
        :quantity="dashboard.reservations_kpi"
        :img="assets.homeNonconformities"
        :to="toAllReservations"
      />
    </v-col>
    <v-col
      cols="12"
      lg="3"
    >
      <kpi-card-component
        :title="$tc('Utilisateurs')"
        :quantity="dashboard.users_kpi"
        :img="assets.homeActions"
        :to="toCompanyMembers"
      />
    </v-col>
  </v-row>
</template>

<script>
import KpiCardComponent from "@/components/ri3/KpiCardComponent.vue"
import { getAssets } from "@/plugins/vuetify"

export default {
  name: "HomeKPI",
  components: {
    KpiCardComponent
  },
  props: {
    dashboard: {
      type: Object
    }
  },
  computed: {
    assets() {
      return getAssets(this)
    }
  },
  data() {
    return {
      toCompanyMembers: { name: "CompanyMembers" },
      toAllCustomers: { name: "AllCustomers" },
      toAllReservations: { name: "AllReservations" },
      toProjects: { name: "Projects" }
    }
  }
}
</script>
